import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Crown } from "lucide-react";

const VipCharter = () => {
  const serviceData = {
    serviceName: "VIP Charter",
    heroImage: require("../../assets/bell429.jpeg"),
    heroTagline: "Luxury Aviation Experience",
    heroDescription:
      "Experience unparalleled luxury with our premium VIP helicopter charter services. Travel in style, comfort, and exclusivity with HighKraft Aviation.",
    overviewTitle: "Premier VIP Helicopter Charter Services",
    overviewText: `HighKraft Aviation offers exclusive VIP helicopter charter services designed for discerning clients who demand the highest standards of luxury, privacy, and convenience. Our VIP charters are perfect for high-net-worth individuals, celebrities, business executives, and anyone seeking a premium travel experience.

Our VIP helicopter fleet features luxurious interiors with premium leather seating, climate control, noise-canceling technology, and ample legroom. Every flight is tailored to meet your specific requirements, from departure timing to in-flight amenities.

With our VIP charter service, you can bypass traffic congestion, avoid crowded airports, and reach your destination in a fraction of the time. Our dedicated crew ensures impeccable service from the moment you arrive until your safe landing.`,
    useCases: [
      {
        title: "Business Travel",
        description:
          "Maximize productivity with point-to-point travel. Arrive fresh and ready for important meetings.",
      },
      {
        title: "Celebrity Transport",
        description:
          "Discreet and private transportation for high-profile individuals away from public attention.",
      },
      {
        title: "Luxury Getaways",
        description:
          "Start your vacation in style with a scenic helicopter transfer to your resort destination.",
      },
      {
        title: "Airport Transfers",
        description:
          "Beat the traffic with quick helicopter transfers to and from major airports.",
      },
      {
        title: "Special Events",
        description:
          "Make a grand entrance at exclusive events, galas, or private parties.",
      },
      {
        title: "Emergency Travel",
        description:
          "When time is critical, our VIP charter gets you where you need to be, fast.",
      },
    ],
    safetyFeatures: [
      {
        title: "DGCA Certified Pilots",
        description:
          "All pilots are certified by DGCA with extensive VIP flight experience and regular training.",
      },
      {
        title: "Premium Fleet Maintenance",
        description:
          "Our aircraft undergo rigorous maintenance checks exceeding industry standards.",
      },
      {
        title: "Comprehensive Insurance",
        description:
          "Full insurance coverage for passengers and cargo ensuring complete peace of mind.",
      },
      {
        title: "Weather Monitoring",
        description:
          "Advanced weather systems ensure flights operate only in safe conditions.",
      },
      {
        title: "Privacy & Confidentiality",
        description:
          "Strict privacy protocols to protect the identity and information of our VIP clients.",
      },
      {
        title: "24/7 Support",
        description:
          "Round-the-clock support team available for any assistance during your journey.",
      },
    ],
    galleryImages: [
      require("../../assets/vip-charter_gal1.jpg"),
      require("../../assets/vip-charter_gal2.jpg"),
      require("../../assets/bgm_highkraft_fleet_vt_bst_mainbackground.jpg"),
    ],
    faqs: [
      {
        question: "What amenities are included in VIP charter flights?",
        answer:
          "Our VIP charter flights include premium leather seating, climate control, complimentary refreshments, noise-canceling headsets, and personalized service. Additional amenities can be arranged upon request.",
      },
      {
        question: "How far in advance should I book a VIP charter?",
        answer:
          "We recommend booking at least 24-48 hours in advance for domestic flights. However, we do accommodate same-day bookings based on availability.",
      },
      {
        question: "Can I customize my flight route?",
        answer:
          "Absolutely! Our VIP charter service offers complete flexibility. You can choose your departure and arrival points, timing, and even scenic routes if desired.",
      },
      {
        question: "Is there a weight limit for luggage?",
        answer:
          "Luggage capacity varies by helicopter model. We recommend discussing your luggage requirements during booking so we can ensure the appropriate aircraft is assigned.",
      },
      {
        question: "What happens if weather conditions are unfavorable?",
        answer:
          "Safety is our priority. If weather conditions prevent safe flying, we will work with you to reschedule at no additional cost or provide alternative arrangements.",
      },
    ],
    icon: Crown,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default VipCharter;
